import { Alert, Button } from '@mui/material';
import { ReportDiff } from '../models/ReportDiff';
import { ReportDone, Report } from '../../common/models/Report';
import { useTranslation } from 'react-i18next';

type Props = {
  currentReport: Report;
  selectedReport: Report | null;
  reportDiff: ReportDiff | null;
  onRecreateComparisonClick: (reportId: number) => void;
};

export const ReportComparisonInfo = (props: Props) => {
  const { currentReport, reportDiff, selectedReport, onRecreateComparisonClick } = props;
  const isSelectedReportDone = selectedReport instanceof ReportDone;
  const isCurrentReportDone = currentReport instanceof ReportDone;
  const isInvalidComparison = !isSelectedReportDone || !isCurrentReportDone;
  const hasVersionsToCompare = currentReport.getVersions().length > 1;
  const { t } = useTranslation();

  if (!hasVersionsToCompare) {
    return (
      <Alert variant="standard" severity="info">
        {t('comparison.infoMessage.noReportsToCompare')}
      </Alert>
    );
  }

  if (isInvalidComparison) {
    return (
      <Alert variant="standard" severity="warning">
        {t('comparison.infoMessage.reportsNotDone')}
      </Alert>
    );
  }

  if (reportDiff?.isFailed()) {
    return (
      <Alert
        severity="error"
        action={
          <Button color="error" variant="text" size="small" onClick={() => onRecreateComparisonClick(selectedReport.getId())}>
            {t('comparison.recreateReportDiffAction')}
          </Button>
        }
      >
        {t('comparison.infoMessage.reportDiffFailed')}
      </Alert>
    );
  }

  return null;
};
